import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import type { RecordModificationResponse } from "#root/utility/remote-data";
import { regex } from "#root/utility/validators";
import type { ReactNode } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { newsRPMInstanceCollection, type NewsRPMInstanceListItem } from "#root/schema/platform/newsrpm-marketplace";
import PageLayout from "./layout";

export default function ({ instanceCode }): ReactNode {
  const navigate = useNavigate();
  const handleUpdate = useCallback(
    (data: RecordModificationResponse<NewsRPMInstanceListItem>) => {
      if ("deleted" in data) {
        navigate("/admin/platform/newsrpm-marketplace/instance");
      } else if ("created" in data) {
        navigate(`/admin/platform/newsrpm-marketplace/instance/${data.created}`);
      }
    },
    [navigate],
  );

  return (
    <PageLayout title="NewsRPM Marketplace - Edit Instance">
      <section>
        <h2>{instanceCode === "new" ? "Create" : "Edit"} Instance</h2>
        <StandardEditor id={instanceCode} collection={newsRPMInstanceCollection} onSave={handleUpdate} onDelete={handleUpdate}>
          <Fields.Set name="code">
            <label>Instance Code</label>
            <Fields.String required validator={regex(/^[a-zA-Z\d-]*$/, "Lowercase letters and numbers only, no spaces or special characters.")}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="networkCode">
            <label>Network Code</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="uri">
            <label>URL</label>
            <Fields.Domain required/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
